export default class Arquivo {
  constructor(id='', nome='') {
    this.id = id;
    this.nome = nome;
    this.extension = nome.substring(nome.length - 3)
    this.avatar = this.extension in this.avatarByExtension ? this.avatarByExtension[this.extension] : this.avatarDefault;
  }

  avatarByExtension = {
    'pdf' : {icon: 'mdi-file-pdf', color: 'red lighten-1'},
    'odt' : {icon: 'mdi-file-document-outline', color: 'blue lighten-1'},
    'txt' : {icon: 'mdi-text-box', color: 'gray lighten-1'},
    'zip' : {icon: 'mdi-zip-box', color: 'orange lighten-1'},
  }

  avatarDefault = {icon: 'mdi-file-document', color: 'green lighten-1'};
}
